import {Button, Col, Form, FormControl, FormGroup, Row} from 'react-bootstrap';
import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom'
import {isSignedUp, register} from '../Helper Functions/UserFunction'
import axios from 'axios';
import objeler from '../components/objeler'
import axiosInstance from '../components/token/axiosInstance'
class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {firstName: "", lastName: "", email: "", password: "", validated: false, error: false};
    }

    async handleSubmit(e) {
        const form = e.currentTarget;
        e.preventDefault();
        var token = '';
        const data = new FormData();
        data.append('Name', this.state.firstName);
        data.append('Surname', this.state.lastName);
        data.append('Email', this.state.email);
        data.append('Password', this.state.password);
        await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/signup', data
        ).then((res) => {
            // M3.5/H6 — backend now returns a JSON User envelope:
            //   status=0   → success
            //   status=103 → weak password (passwordRejectReason in body)
            //   status=100 → generic failure (e.g. write failed)
            // Pre-fix the endpoint returned a plain bool and the frontend
            // only checked HTTP 200, so a server-side false slipped through
            // as "success" — we now read the JSON body.
            if (res.status === 200) {
                let body = res.data;
                // Body may be a JSON string (double-serialized) or already an
                // object depending on axios + content-type handling. Normalize.
                if (typeof body === 'string') {
                    try { body = JSON.parse(body); } catch { body = {}; }
                }
                const status = body && typeof body.status === 'number' ? body.status : -1;

                if (status === 0) {
                    objeler['signup'] = true;
                    this.props.history.push({
                        pathname: '/'
                        , state: {fromUrl: 'Login'}
                    });
                    return;
                }

                if (status === 103) {
                    // Weak password — show a reason-specific message.
                    // Reasons: too_short, too_long, common, contains_email
                    const reasonMessages = {
                        too_short:      'Password is too short. Use at least 8 characters.',
                        too_long:       'Password is too long. Maximum is 128 characters.',
                        common:         'This password is in a list of commonly leaked passwords. Pick something more unique.',
                        contains_email: 'Password must not contain your email address.',
                    };
                    const reason = body && body.passwordRejectReason;
                    const msg = (reason && reasonMessages[reason]) ||
                                'Password does not meet strength requirements.';
                    this.setState({error: true, errorMessage: msg});
                    return;
                }

                // Any other status → generic error.
                this.setState({
                    error: true,
                    errorMessage: 'Sign up failed. Email may already be in use.'
                });
            }
        }).catch(function (error) {
            console.log(error);
        });
        return;
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else {
            const newUser = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                password: this.state.password
            }
            register(newUser).then(res => {
                if (res.success) {
                    this.props.history.push('/profile');
                } else {
                    this.setState({error: true});
                }
            });
        }
        this.setState({validated: true});
    }

    render() {
        // M3.5/H6 — show backend rejection reason if present, else generic msg.
        const errorMsg = (
            <div style={{color: "white"}}>
                {this.state.errorMessage || 'Error: Email already exists or something went wrong.'}
            </div>
        );
        if (isSignedUp()) {
            return <Redirect to="/"/>;
        }
        var fromUrl = "";
        try {
            fromUrl = this.props.location.state.fromUrl
        } catch {
            this.props.history.push('/');
        }
        if (fromUrl != 'Login')
            return (<Redirect to={{pathname: '/'}}/>)
        return (
            <div className="Login">
                <h1 style={{paddingBottom: "20px", fontWeight: "500", color: "white"}}>
                    Sign Up For Free
                </h1>
                <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit.bind(this)}>
                    <Row>
                        <Col>
                            <FormGroup controlId="firstName" bsSize="large">
                                <FormControl
                                    autoFocus
                                    required
                                    value={this.state.firstName}
                                    placeholder="First Name*"
                                    onChange={e => this.setState({firstName: e.target.value})}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a first Name.
                                </Form.Control.Feedback>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup controlId="lastName" bsSize="large">
                                <FormControl
                                    required
                                    value={this.state.lastName}
                                    placeholder="Last Name*"
                                    onChange={e => this.setState({lastName: e.target.value})}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid last Name.
                                </Form.Control.Feedback>
                            </FormGroup>
                        </Col>
                    </Row>
                    <FormGroup controlId="email" bsSize="large">
                        <FormControl
                            type="email"
                            required
                            value={this.state.email}
                            placeholder="Email*"
                            onChange={e => this.setState({email: e.target.value})}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                        </Form.Control.Feedback>
                    </FormGroup>
                    <FormGroup controlId="password" bsSize="large">
                        <FormControl
                            type="password"
                            required
                            value={this.state.password}
                            placeholder="Password*"
                            onChange={e => this.setState({password: e.target.value})}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid password.
                        </Form.Control.Feedback>
                    </FormGroup>
                    <Button block bsSize="large" type="submit">
                        Get Started
                    </Button>
                </Form>
                {this.state.error ? errorMsg : ""}
            </div>
        );
    }
}

export default withRouter(Register);